<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">部门管理</li>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="$judge_auth('148')"
        >添加
      </el-button>
    </ul>
    <ul class="c-list-table" style="margin-top: 10px">
      <el-table
        :data="state.tableData"
        row-key="id"
        default-expand-all
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          prop="name"
          label="名称"
          min-width="180"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.name)
          "
        />
        <el-table-column
          prop="number"
          sortable="number"
          label="编码"
          min-width="100"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.name)
          "
        />
        <el-table-column prop="sort" sortable="sort" label="序号" width="180" />
        <el-table-column
          prop="create_time"
          sortable="create_time"
          label="创建时间"
          width="220"
        />
        <el-table-column
          label="状态"
          prop="status"
          sortable="status"
          width="100"
          fixed="right"
        >
          <template #default="{ row }">
            <el-switch
              v-model="row.status"
              inline-prompt
              active-text="启用"
              active-color="#1e90ff"
              inactive-text="停用"
              inactive-color="#f00"
              :active-value="1"
              :inactive-value="0"
              style="--el-switch-off-color: #f00"
              @change="onChangeQt(row)"
              :disabled="!$judge_auth('151')"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="160"
          align="center"
          fixed="right"
          className="tabBtn"
          v-if="$judge_auth(['149', '150'])"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              v-if="$judge_auth('149')"
            >
              编辑
            </el-button>
            <el-button
              type="danger"
              link
              icon="Delete"
              @click="onDelete(row.id)"
              v-if="$judge_auth('150')"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showInfo"
        :title="(state.selectId ? '修改' : '添加') + '部门'"
        @close="state.showInfo = false"
      >
        <c_DepartmentInfo
          @close="
            state.showInfo = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_DepartmentInfo>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { confirm_func } from "@/utils/qFormat";
import {
  department_tree,
  department_qt,
  department_delete,
} from "@/http/department";
import { ElMessageBox, ElMessage } from "element-plus";

class InitFormData {
  params = {
    limit: 0,
    sort_field: "sort",
    sort_value: "asc",
  };
}

export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoad();
    });

    //加载部门树
    const onLoad = () => {
      delete state.tableData;
      department_tree(state.params).then((res) => {
        if (res.status == 200) {
          state.tableData = res.data.data.list;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //启停
    const onChangeQt = (row) => {
      ElMessageBox.confirm(
        `您确定${
          row.status == 0
            ? '<strong style="color:#f00">停用'
            : '<strong style="color:#1e90ff">启用'
        }</strong>该部门吗？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          department_qt(row).then((res) => {
            if (res.status == 200)
              ElMessage({
                type: "success",
                grouping: true,
                message: res.data.msg,
              });
          });
        })
        .catch(() => {
          row.status = row.status == 1 ? 0 : 1;
        });
    };

    //删除
    const onDelete = (id) => {
      confirm_func(department_delete, id, onLoad);
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
      onChangeQt,
    };
  },
};
</script>
<style scoped lang="less"></style>
